import { FREE_GIFT_IDS } from '@/components/blocks/FreeGiftV2/constants';
import { useFreeGiftInteraction } from '@/components/blocks/FreeGiftV2/context/FreeGiftInteractionContext';
import { useFreeGiftPromotion } from '@/components/blocks/FreeGiftV2/context/FreeGiftPromotionContext';
import { DrawerPurchase } from '@/components/blocks/FreeGiftV2/parts/DrawerPurchase';
import { DrawerReward } from '@/components/blocks/FreeGiftV2/parts/DrawerReward';
import { NumberBadge } from '@/components/blocks/FreeGiftV2/parts/NumberBadge';
import { clearFreeGiftSelection } from '@/components/blocks/FreeGiftV2/utils';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import {
	MATERIAL_SYMBOL_ICONS,
	OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

export const DrawerContent = () => {
	const labels = useLocalization('FreeGift');
	const theme = useTheme();
	const {
		setShowPromotionOptions,
		setSelectedPurchaseGroupId,
		setSelectedPurchaseSkus,
		setSelectedRewardGroupId,
		setSelectedRewardSkus,
		setPromotionQty,
		setIsPromotionComplete,
		setHasAddedToCart,
		isRewardView,
	} = useFreeGiftInteraction();
	const { promotionGroups, setSelectedPromotionIndex, currentPartNumber } = useFreeGiftPromotion();
	const hasMultiplePromotions = promotionGroups.length > 1;

	const handleGoBack = () => {
		setSelectedPromotionIndex(-1);
		setSelectedPurchaseGroupId(undefined);
		setSelectedPurchaseSkus([]);
		setSelectedRewardGroupId(undefined);
		setSelectedRewardSkus([]);
		setPromotionQty(1);
		setIsPromotionComplete(false);
		setHasAddedToCart(false);
		clearFreeGiftSelection(currentPartNumber);
		setShowPromotionOptions(true);
	};

	return (
		<Stack display="flex" gap="20px">
			{hasMultiplePromotions ? (
				<Box
					display="flex"
					alignItems="center"
					id={isRewardView ? FREE_GIFT_IDS.backButtonReward : FREE_GIFT_IDS.backButton}
				>
					<DynamicIcon
						name={MATERIAL_SYMBOL_ICONS.chevronLeft}
						variant="rounded"
						color={theme.palette.secondary.main}
						size="25px"
					/>
					<Typography
						variant="bodySubText"
						color="secondary.main"
						onClick={handleGoBack}
						sx={{ cursor: 'pointer' }}
					>
						{labels.GoBack.t()}
					</Typography>
				</Box>
			) : null}
			<Stack display="flex" gap="15px">
				<Stack display="flex" gap="15px" id={FREE_GIFT_IDS.triggerSection}>
					<Box display="flex" alignItems="center" gap="5px">
						<NumberBadge num={1} />
						<Typography
							variant="bodyBaseline"
							fontWeight={OpenSansFontWeights.semibold}
							color="grey.500"
						>
							{labels.Buy.t()}
						</Typography>
					</Box>
					<DrawerPurchase />
				</Stack>
				<Stack display="flex" gap="15px" id={FREE_GIFT_IDS.giftSection}>
					<Box display="flex" alignItems="center" gap="5px">
						<NumberBadge num={2} />
						<Typography
							variant="bodyBaseline"
							fontWeight={OpenSansFontWeights.semibold}
							component="h3"
							color="grey.500"
						>
							{labels.TakeFree.t()}
						</Typography>
					</Box>
					<DrawerReward />
				</Stack>
			</Stack>
		</Stack>
	);
};
